import { pathOr } from 'ramda'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { selectToken } from '@/app/module/auth/store/selectors'

import Organization from './component/organization'
import { downloadAuditLog, switchOrganization } from './store/actions'
import { selectOrgId, selectUserId, selectUserPermissions, selectUserRole } from './store/selectors'

const orgSelector = ({ user }) => ({
  error: user.organization.error,
  token: selectToken(),
  orgId: selectOrgId({ user }),
  loading: user.organization.loading,
  details: pathOr({}, ['details', 'data'], user),
  role: selectUserRole({ user }),
  permissions: selectUserPermissions({ user }),
  userId: selectUserId({ user }),
})

const orgDispatcher = (dispatch) =>
  bindActionCreators(
    {
      switchOrganization,
      downloadAuditLog,
    },
    dispatch,
  )

export const UserOrganization = connect(orgSelector, orgDispatcher)(Organization)
